/**
 * Session Management Utilities (S2)
 * Handles session ID generation and persistence for guest cart tracking
 */

const SESSION_ID_KEY = 'arkx_session_id';

/**
 * Generate a UUID v4
 */
function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
}

/**
 * Get or create session ID
 * Returns existing session ID from localStorage or creates new one
 */
export function getSessionId(): string {
  try {
    let sessionId = localStorage.getItem(SESSION_ID_KEY);

    if (!sessionId) {
      sessionId = generateUUID();
      localStorage.setItem(SESSION_ID_KEY, sessionId);
    }

    return sessionId;
  } catch (error) {
    // Fallback if localStorage is unavailable (incognito mode, etc.)
    return generateUUID();
  }
}

/**
 * Clear session ID
 * Used when user logs out or wants to start fresh cart
 */
export function clearSessionId(): void {
  try {
    localStorage.removeItem(SESSION_ID_KEY);
  } catch {
    // Silently fail if localStorage is unavailable
  }
}

/**
 * Regenerate session ID
 * Used after user logs in to create new authenticated session
 */
export function regenerateSessionId(): string {
  clearSessionId();
  return getSessionId();
}
